const subUsersFR = {
    "view": {
        "table": {
            "title": "Votre liste de sous-utilisateurs",
            "column": {
                "username": "Nom d'utilisateur",
                "email": "Email",
                "first_name": "Prénom",
                "last_name": "Nom de famille",
                "company": "Entreprise",
                "sub_user_deal": "Accord (%)",
                "contract_expiry": "Expiration du contrat",
                "is_active": "Actif",
                "action": "Action"
            },
            "button": {
                "edit": "Modifier",
                "export_csv": "Exporter CSV"
            },
            "placeholder": {
                "search": "Rechercher..."
            },
            "label": {
                "yes": "Oui",
                "no": "Non"
            },
            "dropdown": {
                "action": "Action",
                "edit": "Modifier",
                "activate": "Activer",
                "deactivate": "Désactiver"
            }
        },
        "message": {
            "successUpdated": "Le compte du sous-utilisateur a été mis à jour !",
            "successActivated": "Le compte du sous-utilisateur a été activé !",
            "successDeactivated": "Le compte du sous-utilisateur a été désactivé !",
            "error": "Quelque chose s'est mal passé ! Veuillez rafraîchir la page et réessayer !",
            "premiumUsersOnly": "Cette fonctionnalité est offerte uniquement aux utilisateurs Premium. Veuillez contacter l'équipe de support si vous souhaitez mettre à niveau votre compte.",
            "noAccess": "Vous n'avez pas accès à ce module, veuillez contacter l'équipe de support pour plus d'informations."
        },
        "modal": {
            "activateSubuser": {
                "header": "Activer le sous-utilisateur",
                "body": "Êtes-vous sûr de vouloir activer le sous-utilisateur {{username}} ?"
            },
            "deactivateSubuser": {
                "header": "Désactiver le sous-utilisateur",
                "body": "Êtes-vous sûr de vouloir désactiver le sous-utilisateur {{username}} ?"
            },
            "button": {
                "cancel": "Annuler",
                "edit": "Modifier",
                "activate": "Activer",
                "deactivate": "Désactiver"
            }
        }
    },
    "add": {
        "title": "Ajouter un sous-utilisateur",
        "form": {
            "label": {
                "personalDetails": "Détails personnels",
                "firstName": "Prénom",
                "lastName": "Nom de famille",
                "email": "Email",
                "username": "Nom d'utilisateur",
                "password": "Mot de passe",
                "confirmPassword": "Confirmer le mot de passe",
                "businessDetails": "Détails de l'entreprise",
                "companyName": "Nom de l'entreprise",
                "contractExpiry": "Expiration du contrat",
                "subUserDeal": "Accord du sous-utilisateur (%)",
                "nationalTaxNumber": "Numéro d'identification fiscale",
                "businessRegistrationNumber": "Numéro d'enregistrement de l'entreprise",
                "contactDetails": "Détails de contact",
                "streetAndNumber": "Rue et numéro",
                "postalCode": "Code postal",
                "city": "Ville",
                "country": "Pays",
                "phoneNumber": "Numéro de téléphone"
            },
            "help_text": {
                "contractExpiry": "Remarque : La date d'expiration du contrat ne peut pas être antérieure à {{afterOneYear}}."
            },
            "button": {
                "submit": "Soumettre"
            }
        },
        "message": {
            "success": "Le sous-utilisateur a été ajouté !",
            "error": "Quelque chose s'est mal passé ! Veuillez rafraîchir la page et réessayer !"
        },
        "modal": {
            "header": "Ajouter un sous-utilisateur",
            "body": "Êtes-vous sûr de vouloir créer un nouveau sous-utilisateur ?"
        }
    },
    "update": {
        "title": "Modifier le sous-utilisateur",
        "form": {
            "label": {
                "personalDetails": "Détails personnels",
                "firstName": "Prénom",
                "lastName": "Nom de famille",
                "email": "Email",
                "username": "Nom d'utilisateur",
                "password": "Mot de passe",
                "confirmPassword": "Confirmer le mot de passe",
                "businessDetails": "Détails de l'entreprise",
                "companyName": "Nom de l'entreprise",
                "contractExpiry": "Expiration du contrat",
                "subUserDeal": "Accord du sous-utilisateur (%)",
                "nationalTaxNumber": "Numéro d'identification fiscale",
                "businessRegistrationNumber": "Numéro d'enregistrement de l'entreprise",
                "contactDetails": "Détails de contact",
                "streetAndNumber": "Rue et numéro",
                "postalCode": "Code postal",
                "city": "Ville",
                "country": "Pays",
                "phoneNumber": "Numéro de téléphone"
            },
            "help_text": {
                "contractExpiry": "Remarque : La date d'expiration du contrat ne peut pas être antérieure à {{afterOneYear}}."
            },
            "button": {
                "submit": "Soumettre"
            }
        },
        "message": {
            "success": "Le sous-utilisateur a été mis à jour !",
            "error": "Quelque chose s'est mal passé ! Veuillez rafraîchir la page et réessayer !"
        }
    }
};

export default subUsersFR;